<template>
  <div class="py-2">
      <div class="unishop-order-name"></div>
      <div class="image mr-2" :style="{ backgroundImage: 'url(' + foto  + ')' }"></div>
      <div class="unishop-order-desc mb-2">
          <div class="unishop-order-price">
              <p class="body-2 text-uppercase mb-1 font-weight-medium">
                {{ producto.modelo }} {{ producto.color }}{{ lineaticket.mslt_codigo_escaneo }}
              </p>
              <div class="d-flex justify-space-between">
                <span class="no-flex">
                {{ lineaticket.mslt_unidades }}
                Und.
              </span>
                <span class="no-flex">
              {{ formatMoney(lineaticket.mslt_precio) }}
                </span>
              </div>
            <div class="font-weight-light caption d-flex jsutify-space-between">
              <span>Descuento</span>
              <span class="no-flex">{{ formatMoney(lineaticket.mslt_descuento) }}</span>
            </div>
          </div>
          <!-- <div class="unishop-order-options"><span>Talla: {{ }}</span></div> -->
      </div>
      <v-divider></v-divider>
  </div>          
</template>
<script>
import { TiendaApiService } from '@/api/TiendaApiService'
import { Util } from '@/api/Util'
const tiendaApiService = new TiendaApiService()
const util = new Util()

export default {
  name: 'lineaTicket',
  props: ['lineaticket'],
  
  data () { 
    return {
      producto: {
        modelo: '',
        color: '',
      },
      foto: '',
      talla: '',
    };
  },
  mounted () {
    this.init()
  },
  methods: {
    init() {
      this.getArticuloByCod();
    },
    formatMoney (num) {
      return util.formatMoney(num)
    },
    getArticuloByCod () {
      tiendaApiService.getArticuloByCod(this.lineaticket.mslt_codigo_escaneo)
        .then(data => {
          if (data.articulo) {
              this.producto = data.articulo
              this.talla = data.talla
              this.getFoto()
          } else {
            this.producto.modelo = 'Articulo no encontrado'
            this.producto.color = ''
            this.foto = ''
          }
        })
        .catch(error => {
          //this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
          this.producto.modelo = 'Articulo no encontrado'
          this.producto.color = ''
          this.foto = ''
          util.mostrarEnConsola('tiendaApiService - getArticuloByCod', error, 'ERROR')
        })

    },
    getFoto() {
      if (this.producto.fotos.length > 0) {
        this.foto = this.producto.fotos[0].url
      }   
    },
    addToCart () {
      //console.log(this.producto)
      if (this.producto) {
        // this.error = false
        Object.assign(this.producto, {cantidad: this.lineaticket.mslt_unidades})
        Object.assign(this.producto, {codigo: this.lineaticket.mslt_codigo_escaneo})
        Object.assign(this.producto, {precio: this.lineaticket.mslt_precio})
        if (this.producto.talla !== '') {
          Object.assign(this.producto, {talla: this.producto.talla})
        } else {
          let eanAux;
          for (var i = 0; i < this.producto.tallas.length; i++) {
            eanAux = this.producto.tallas[i].eans.find( ean => ean.ean === this.lineaticket.mslt_codigo_escaneo ); 
          }
          if (eanAux) {
            Object.assign(this.producto, {talla: this.eanAux.ean})
          }
        }
        Object.assign(this.producto, {foto: this.foto})
        this.$store.commit('addToCart', this.producto)
        return true
        //this.$emit('cerrar')
      } else {
        console.log('error desaparcar' + this.producto)
        return true
        // this.error = true
      }
    },
  }

};
</script>